import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    negrito: {
        fontWeight: 'bold',
    },
    card: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        }
    },
    icon: {
        width: 40,
        height: 40,
    },
    selecionado: {
        backgroundColor: theme.palette.action.selected,
        border: `1px solid ${theme.palette.primary.main}`,
    }
}))